module.exports = __webpack_public_path__ + "img/transparent_xls.0a145ca0.svg";